import React from 'react';
import { Alert, AlertTitle, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface ErrorAlertProps {
  message: string;
  onClose: () => void;
  show: boolean;
}

const ErrorAlert = ({ message, onClose, show }: ErrorAlertProps) => {
  if (!show) return null;

  return (
    <Box sx={{ mb: 2 }}>
      <Alert 
        severity="error" 
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={onClose}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
        sx={{
          '& .MuiAlert-message': {
            width: '100%'
          }
        }}
      >
        <AlertTitle>Error</AlertTitle>
        {message}
      </Alert>
    </Box>
  );
};

export default ErrorAlert;